export const getFormattedDate = (date, format = 'mm/dd/yyyy') => {
  const year = new Date(date).getFullYear()
  const month = new Date(date).getMonth() + 1 > 9 ? new Date(date).getMonth() + 1 : `0${new Date(date).getMonth() + 1}`
  const day = new Date(date).getDate() > 9 ? new Date(date).getDate() : `0${new Date(date).getDate()}`

  switch (format) {
    case 'mm/dd/yyyy':
      return `${month}/${day}/${year}`

    case 'dd/mm/yyyy':
      return `${day}/${month}/${year}`

    case 'yyyy/mm/dd':
      return `${year}/${month}/${day}`

    default:
      return `${month}/${day}/${year}`
  }
}

export function getDateFromDayspan(dayspan) {
  var result = new Date()
  result.setDate(result.getDate() - dayspan)
  return result
}

export const getBaseunits = dayspanSelected => {
  switch (dayspanSelected) {
    case 30:
      return 'days'
    case 60:
      return 'weeks'
    default:
      return 'months'
  }
}
